import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Button,
  Typography,
  makeStyles
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles(theme => ({
  dialogContent: {
    whiteSpace: 'pre-line',
    paddingTop: theme.spacing(0)
  },
  alert: {
    marginTop: theme.spacing(2)
  },
  dialogActions: {
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    paddingBottom: theme.spacing(1)
  }
}));

const ResourcingValidationErrorDialog = ({
  open,
  onClose,
  onRefresh,
  errorMessageId
}) => {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <FormattedMessage id="resourcingValidationErrorDialog.dialogTitle" />
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography variant="body1" gutterBottom>
          <FormattedMessage id="resourcingValidationErrorDialog.dialogMessage" />
        </Typography>
        <Alert severity="error" className={classes.alert}>
          <Typography variant="body2">
            <FormattedMessage id={errorMessageId} />
          </Typography>
        </Alert>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button onClick={onRefresh} color="primary">
          <FormattedMessage id="resourcingValidationErrorDialog.refreshButton" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ResourcingValidationErrorDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired,
  errorMessageId: PropTypes.string.isRequired
};

export default ResourcingValidationErrorDialog;
